import { Injectable } from '@angular/core';
import * as firebase from 'firebase';
import{ServicioFechasQueryService} from './servicio-fechas-query.service'


@Injectable({
  providedIn: 'root'
})
export class ServiDataService {

  constructor(public servicioFechasQueryService:ServicioFechasQueryService,) { }

//FORMATO DE INFORMACION PARA CHART 1
  dataChart1 = [
    {
      "name": "VMM",
      "series": [
        {
          "name": "Pendiente de aprobación",
          "value": 0
        },
        {
          "name": "Aprobado",
          "value": 0
        }, 
        {
          "name": "Denegado",
          "value": 0
        },
        {
          "name": "Cerrado",
          "value": 0
        },
        {
          "name": "Cerrado",
          "value": 0
        }
      ]
    },
    {
      "name": "VMM-otros",
      "series": [
        {
          "name": "Pendiente de aprobación",
          "value": 0
        },
        {
          "name": "Aprobado",
          "value": 0
        }, 
        {
          "name": "Denegado",
          "value": 0
        },
        {
          "name": "Cerrado",
          "value": 0
        },
        {
          "name": "Cerrado",
          "value": 0
        }
      ]
    },
  
    {
      "name": "Put. norte",
      "series": [
        {
          "name": "Pendiente de aprobación",
          "value": 0
        },
        {
          "name": "Aprobado",
          "value": 0
        }, 
        {
          "name": "Denegado",
          "value": 0
        },
        {
          "name": "Cerrado",
          "value": 0
        },
        {
          "name": "Cerrado",
          "value": 0
        }
      ]
    },
  
    {
      "name": "Put. Sur",
      "series": [
        {
          "name": "Pendiente de aprobación",
          "value": 0
        },
        {
          "name": "Aprobado",
          "value": 0
        }, 
        {
          "name": "Denegado",
          "value": 0
        },
        {
          "name": "Cerrado",
          "value": 0
        },
        {
          "name": "Cerrado",
          "value": 0
        }
      ]
    },

    {
      "name": "Bogotá",
      "series": [
        {
          "name": "Pendiente de aprobación",
          "value": 0
        },
        {
          "name": "Aprobado",
          "value": 0
        }, 
        {
          "name": "Denegado",
          "value": 0
        },
        {
          "name": "Cerrado",
          "value": 0
        },
        {
          "name": "Cerrado",
          "value": 0
        }
      ]
    },
    {
      "name": "Llanos",
      "series": [
        {
          "name": "Pendiente de aprobación",
          "value": 0
        },
        {
          "name": "Aprobado",
          "value": 0
        }, 
        {
          "name": "Denegado",
          "value": 0
        },
        {
          "name": "Cerrado",
          "value": 0
        },
        {
          "name": "Cerrado",
          "value": 0
        }
      ]
    },
    {
      "name": "Charapa",
      "series": [
        {
          "name": "Pendiente de aprobación",
          "value": 0
        },
        {
          "name": "Aprobado",
          "value": 0
        }, 
        {
          "name": "Denegado",
          "value": 0
        },
        {
          "name": "Cerrado",
          "value": 0
        },
        {
          "name": "Cerrado",
          "value": 0
        }
      ]
    },
    {
      "name": "Chanangue",
      "series": [
        {
          "name": "Pendiente de aprobación",
          "value": 0
        },
        {
          "name": "Aprobado",
          "value": 0
        }, 
        {
          "name": "Denegado",
          "value": 0
        },
        {
          "name": "Cerrado",
          "value": 0
        },
        {
          "name": "Cerrado",
          "value": 0
        }
      ]
    },
    {
      "name": "Iguana",
      "series": [
        {
          "name": "Pendiente de aprobación",
          "value": 0
        },
        {
          "name": "Aprobado",
          "value": 0
        }, 
        {
          "name": "Denegado",
          "value": 0
        },
        {
          "name": "Cerrado",
          "value": 0
        },
        {
          "name": "Cerrado",
          "value": 0
        }
      ]
    },
     {
      "name": "VMM - SR & TSQ",
      "series": [
        {
          "name": "Pendiente de aprobación",
          "value": 0
        },
        {
          "name": "Aprobado",
          "value": 0
        }, 
        {
          "name": "Denegado",
          "value": 0
        },
        {
          "name": "Cerrado",
          "value": 0
        },
        {
          "name": "Cerrado",
          "value": 0
        }
      ]
    },
    
  ];

  //FORMATO DE INFORMACION PARA CHART 2
  dataChart2 = [
    {
      "name": "VMM",
      "value": 0
    },
    {
      "name": "VMM-Otros",
      "value": 0
    },
  
    {
      "name": "Put.Norte",
      "value": 0
    },
    {
      "name": "Put.Sur",
      "value": 0
    },
    {
      "name": "Bogotá",
      "value": 0
    },
    {
      "name": "Llanos",
      "value": 0
    },
    {
      "name": "Charapa",
      "value": 0
    },
    {
      "name": "Chanangue",
      "value": 0
    },
    {
      "name": "Iguana",
      "value": 0
    },
      {
      "name": "VMM - SR & TSQ",
      "value": 0
    },
  ];

  //FORMATO DE INFORMACION PARA CHART 3
  dataChart3drilling=[
    {
      "name": "Pendiente de aprobación",
      "value": 0
    },
    {
      "name": "Aprobado",
      "value": 0
    },
    {
      "name": "Denegado",
      "value": 0
    },
    {
      "name": "Cerrado",
      "value": 0
    },
    {
      "name": "Cerrado",
      "value": 0
    }
  ]

  dataChart3Produccion=[
    {
      "name": "Pendiente de aprobación",
      "value": 0
    },
    {
      "name": "Aprobado",
      "value": 0
    },
    {
      "name": "Denegado",
      "value": 0
    },
    {
      "name": "Cerrado",
      "value": 0
    },
    {
      "name": "Cerrado",
      "value": 0
    }
  ]

  dataChart3workover=[
    {
      "name": "Pendiente de aprobación",
      "value": 0
    },
    {
      "name": "Aprobado",
      "value": 0
    },
    {
      "name": "Denegado",
      "value": 0
    },
    {
      "name": "Cerrado",
      "value": 0
    },
    {
      "name": "Cerrado",
      "value": 0
    }
  ]

  dataChart3sismica=[
    {
      "name": "Pendiente de aprobación",
      "value": 0
    },
    {
      "name": "Aprobado",
      "value": 0
    },
    {
      "name": "Denegado",
      "value": 0
    },
    {
      "name": "Cerrado",
      "value": 0
    },
    {
      "name": "Cerrado",
      "value": 0
    }
  ];

  dataChart3ProyectosYfacilidades=[
    {
      "name": "Pendiente de aprobación",
      "value": 0
    },
    {
      "name": "Aprobado",
      "value": 0
    },
    {
      "name": "Denegado",
      "value": 0
    },
    {
      "name": "Cerrado",
      "value": 0
    },
    {
      "name": "Cerrado",
      "value": 0
    }
  ];

  dataChart3Logistica=[
    {
      "name": "Pendiente de aprobación",
      "value": 0
    },
    {
      "name": "Aprobado",
      "value": 0
    },
    {
      "name": "Denegado",
      "value": 0
    },
    {
      "name": "Cerrado",
      "value": 0
    },
    {
      "name": "Cerrado",
      "value": 0
    }
  ];

  dataChart3mantenimiento=[
    {
      "name": "Pendiente de aprobación",
      "value": 0
    },
    {
      "name": "Aprobado",
      "value": 0
    },
    {
      "name": "Denegado",
      "value": 0
    },
    {
      "name": "Cerrado",
      "value": 0
    },
    {
      "name": "Cerrado",
      "value": 0
    }
  ];

  dataChart3administracion=[
    {
      "name": "Pendiente de aprobación",
      "value": 0
    },
    {
      "name": "Aprobado",
      "value": 0
    },
    {
      "name": "Denegado",
      "value": 0
    },
    {
      "name": "Cerrado",
      "value": 0
    },
    {
      "name": "Cerrado",
      "value": 0
    }
  ];

  
  // Drilling
// Producción
// Workover
// Sísmica
// Proyectos y facilidades
// Logística
// Mantenimiento
// Administración

//QUERY PARA CHART 1
queryChart1(callback){
  this.resetea(()=>{
      let  fechaquerymin = this.servicioFechasQueryService.fechaquerymin
      let  fechaquerymax = this.servicioFechasQueryService.fechaquerymax
      
      let query1 = firebase.firestore().collection("ptws").where("fechainicio", ">=", fechaquerymin).where("fechainicio", "<=", fechaquerymax);
      
      query1.get().then((docs)=>{
        docs.forEach((doc)=>{
          this.clasificaChart1(doc)
          this.clasificaChart2(doc)
          this.clasificaChart3(doc)
          this.clasificaChart4(doc)
          this.clasificaChart5(doc)
          this.clasificaChart6(doc)
          this.clasificaChart7(doc)
          this.clasificaChart8(doc)
          this.clasificaChart9(doc)
          this.clasificaChart10(doc)
        })
        // this.dataChart1=[...this.dataChart1]
      }).catch((err)=>{
        console.log(err);
      }).then(()=>{
        callback(this.dataChart1, this.dataChart2, this.dataChart3drilling, this.dataChart3Produccion, this.dataChart3workover, this.dataChart3sismica, this.dataChart3ProyectosYfacilidades, this.dataChart3Logistica, this.dataChart3mantenimiento,this.dataChart3administracion)
      })
  })//fin de resetea
}//fin de queryChart1

//ORGANIZA DATA PARA CHART 1
clasificaChart1(doc){
  if(doc.data().cuenca == 'VMM' && doc.data().status == 'Pendiente de aprobación'){this.dataChart1[0].series[0].value ++}else
  if(doc.data().cuenca == 'VMM' && doc.data().status == 'Aprobado'){this.dataChart1[0].series[1].value ++ }else
  if(doc.data().cuenca == 'VMM' && doc.data().status == 'Denegado'){this.dataChart1[0].series[2].value ++ }else
  if(doc.data().cuenca == 'VMM' && doc.data().status == 'Cerrado'){this.dataChart1[0].series[3].value ++ }else
  if(doc.data().cuenca == 'VMM' && doc.data().status == 'Cerrado'){this.dataChart1[0].series[4].value ++ }else

  if(doc.data().cuenca == 'VMM-otros' && doc.data().status == 'Pendiente de aprobación'){this.dataChart1[1].series[0].value ++ }else
  if(doc.data().cuenca == 'VMM-otros' && doc.data().status == 'Aprobado'){this.dataChart1[1].series[1].value ++ }else
  if(doc.data().cuenca == 'VMM-otros' && doc.data().status == 'Denegado'){this.dataChart1[1].series[2].value ++ }else
  if(doc.data().cuenca == 'VMM-otros' && doc.data().status == 'Cerrado'){this.dataChart1[1].series[3].value ++ }else
  if(doc.data().cuenca == 'VMM-otros' && doc.data().status == 'Cerrado'){this.dataChart1[1].series[4].value ++ }else



  if(doc.data().cuenca == 'Putumayo norte' && doc.data().status == 'Pendiente de aprobación'){this.dataChart1[2].series[0].value ++ }else
  if(doc.data().cuenca == 'Putumayo norte' && doc.data().status == 'Aprobado'){this.dataChart1[2].series[1].value ++ }else
  if(doc.data().cuenca == 'Putumayo norte' && doc.data().status == 'Denegado'){this.dataChart1[2].series[2].value ++ }else
  if(doc.data().cuenca == 'Putumayo norte' && doc.data().status == 'Cerrado'){this.dataChart1[2].series[3].value ++ }else
  if(doc.data().cuenca == 'Putumayo norte' && doc.data().status == 'Cerrado'){this.dataChart1[2].series[4].value ++ }else

  if(doc.data().cuenca == 'Putumayo sur' && doc.data().status == 'Pendiente de aprobación'){this.dataChart1[3].series[0].value ++ }else
  if(doc.data().cuenca == 'Putumayo sur' && doc.data().status == 'Aprobado'){this.dataChart1[3].series[1].value ++ }else
  if(doc.data().cuenca == 'Putumayo sur' && doc.data().status == 'Denegado'){this.dataChart1[3].series[2].value ++ }else
  if(doc.data().cuenca == 'Putumayo sur' && doc.data().status == 'Cerrado'){this.dataChart1[3].series[3].value ++ }else
  if(doc.data().cuenca == 'Putumayo sur' && doc.data().status == 'Cerrado'){this.dataChart1[3].series[4].value ++ }else


  if(doc.data().cuenca == 'Bogota' && doc.data().status == 'Pendiente de aprobación'){this.dataChart1[4].series[0].value ++ }else
  if(doc.data().cuenca == 'Bogota' && doc.data().status == 'Aprobado'){this.dataChart1[4].series[1].value ++ }else
  if(doc.data().cuenca == 'Bogota' && doc.data().status == 'Denegado'){this.dataChart1[4].series[2].value ++ }else
  if(doc.data().cuenca == 'Bogota' && doc.data().status == 'Cerrado'){this.dataChart1[4].series[3].value ++ }else
  if(doc.data().cuenca == 'Bogota' && doc.data().status == 'Cerrado'){this.dataChart1[5].series[4].value ++ }else

  if(doc.data().cuenca == 'Llanos' && doc.data().status == 'Pendiente de aprobación'){this.dataChart1[5].series[0].value ++ }else
  if(doc.data().cuenca == 'Llanos' && doc.data().status == 'Aprobado'){this.dataChart1[5].series[1].value ++ }else
  if(doc.data().cuenca == 'Llanos' && doc.data().status == 'Denegado'){this.dataChart1[5].series[2].value ++ }else
  if(doc.data().cuenca == 'Llanos' && doc.data().status == 'Cerrado'){this.dataChart1[5].series[3].value ++ }else
  if(doc.data().cuenca == 'Llanos' && doc.data().status == 'Cerrado'){this.dataChart1[6].series[4].value ++ }else

  if(doc.data().cuenca == 'Charapa' && doc.data().status == 'Pendiente de aprobación'){this.dataChart1[6].series[0].value ++ }else
  if(doc.data().cuenca == 'Charapa' && doc.data().status == 'Aprobado'){this.dataChart1[6].series[1].value ++ }else
  if(doc.data().cuenca == 'Charapa' && doc.data().status == 'Denegado'){this.dataChart1[6].series[2].value ++ }else
  if(doc.data().cuenca == 'Charapa' && doc.data().status == 'Cerrado'){this.dataChart1[6].series[3].value ++ }else
  if(doc.data().cuenca == 'Charapa' && doc.data().status == 'Cerrado'){this.dataChart1[7].series[4].value ++ }else

  if(doc.data().cuenca == 'Chanangue' && doc.data().status == 'Pendiente de aprobación'){this.dataChart1[7].series[0].value ++ }else
  if(doc.data().cuenca == 'Chanangue' && doc.data().status == 'Aprobado'){this.dataChart1[7].series[1].value ++ }else
  if(doc.data().cuenca == 'Chanangue' && doc.data().status == 'Denegado'){this.dataChart1[7].series[2].value ++ }else
  if(doc.data().cuenca == 'Chanangue' && doc.data().status == 'Cerrado'){this.dataChart1[7].series[3].value ++ }else
  if(doc.data().cuenca == 'Chanangue' && doc.data().status == 'Cerrado'){this.dataChart1[8].series[4].value ++ }else

  if(doc.data().cuenca == 'Iguana' && doc.data().status == 'Pendiente de aprobación'){this.dataChart1[8].series[0].value ++ }else
  if(doc.data().cuenca == 'Iguana' && doc.data().status == 'Aprobado'){this.dataChart1[8].series[1].value ++ }else
  if(doc.data().cuenca == 'Iguana' && doc.data().status == 'Denegado'){this.dataChart1[8].series[2].value ++ }else
  if(doc.data().cuenca == 'Iguana' && doc.data().status == 'Cerrado'){this.dataChart1[8].series[3].value ++ }else
  if(doc.data().cuenca == 'Iguana' && doc.data().status == 'Cerrado'){this.dataChart1[9].series[4].value ++ }

  if(doc.data().cuenca == 'VMM - SR & TSQ' && doc.data().status == 'Pendiente de aprobación'){this.dataChart1[1].series[0].value ++ }else
  if(doc.data().cuenca == 'VMM - SR & TSQ' && doc.data().status == 'Aprobado'){this.dataChart1[9].series[1].value ++ }else
  if(doc.data().cuenca == 'VMM - SR & TSQ' && doc.data().status == 'Denegado'){this.dataChart1[9].series[2].value ++ }else
  if(doc.data().cuenca == 'VMM - SR & TSQ' && doc.data().status == 'Cerrado'){this.dataChart1[9].series[3].value ++ }else
  if(doc.data().cuenca == 'VMM - SR & TSQ' && doc.data().status == 'Cerrado'){this.dataChart1[9].series[4].value ++ }

}


clasificaChart2(doc){
  if(doc.data().cuenca == 'VMM' ){this.dataChart2[0].value ++}else
  if(doc.data().cuenca == 'VMM-otros'){this.dataChart2[1].value ++}else
  if(doc.data().cuenca == 'Putumayo norte'){this.dataChart2[2].value ++}else
  if(doc.data().cuenca == 'Putumayo sur'){this.dataChart2[3].value ++}else
  if(doc.data().cuenca == 'Bogota'){this.dataChart2[4].value ++}else
  if(doc.data().cuenca == 'Llanos'){this.dataChart2[5].value ++}else
  if(doc.data().cuenca == 'Charapa'){this.dataChart2[6].value ++}else
  if(doc.data().cuenca == 'Chanangue'){this.dataChart2[7].value ++}else
  if(doc.data().cuenca == 'Iguana'){this.dataChart2[8].value ++}
  if(doc.data().cuenca == 'VMM - SR & TSQ'){this.dataChart2[9].value ++}
}

//drilling
clasificaChart3(doc){
  if(doc.data().status == 'Pendiente de aprobación' && doc.data().unidadDeNegocio =='Drilling'  ){this.dataChart3drilling[0].value ++}else
  if(doc.data().status == 'Aprobado' && doc.data().unidadDeNegocio =='Drilling'){this.dataChart3drilling[1].value ++}else
  if(doc.data().status == 'Denegado' && doc.data().unidadDeNegocio =='Drilling'){this.dataChart3drilling[2].value ++}else
  if(doc.data().status == 'Cerrado'  && doc.data().unidadDeNegocio =='Drilling'){this.dataChart3drilling[3].value ++}else
  if(doc.data().status == 'Cerrado'  && doc.data().unidadDeNegocio =='Drilling'){this.dataChart3drilling[4].value ++}
}

// Producción
clasificaChart4(doc){
  if(doc.data().status == 'Pendiente de aprobación' && doc.data().unidadDeNegocio =='Producción'  ){this.dataChart3Produccion[0].value ++}else
  if(doc.data().status == 'Aprobado' && doc.data().unidadDeNegocio =='Producción'){this.dataChart3Produccion[1].value ++}else
  if(doc.data().status == 'Denegado' && doc.data().unidadDeNegocio =='Producción'){this.dataChart3Produccion[2].value ++}else
  if(doc.data().status == 'Cerrado'  && doc.data().unidadDeNegocio =='Producción'){this.dataChart3Produccion[3].value ++}else
  if(doc.data().status == 'Cerrado'  && doc.data().unidadDeNegocio =='Producción'){this.dataChart3Produccion[4].value ++}
}

// workover
clasificaChart5(doc){
  if(doc.data().status == 'Pendiente de aprobación' && doc.data().unidadDeNegocio =='Workover'  ){this.dataChart3workover[0].value ++}else
  if(doc.data().status == 'Aprobado' && doc.data().unidadDeNegocio =='Workover'){this.dataChart3workover[1].value ++}else
  if(doc.data().status == 'Denegado' && doc.data().unidadDeNegocio =='Workover'){this.dataChart3workover[2].value ++}else
  if(doc.data().status == 'Cerrado'  && doc.data().unidadDeNegocio =='Workover'){this.dataChart3workover[3].value ++}else
  if(doc.data().status == 'Cerrado'  && doc.data().unidadDeNegocio =='Workover'){this.dataChart3workover[4].value ++}
}

// sismica
clasificaChart6(doc){
  if(doc.data().status == 'Pendiente de aprobación' && doc.data().unidadDeNegocio =='Sísmica'  ){this.dataChart3sismica[0].value ++}else
  if(doc.data().status == 'Aprobado' && doc.data().unidadDeNegocio =='Sísmica'){this.dataChart3sismica[1].value ++}else
  if(doc.data().status == 'Denegado' && doc.data().unidadDeNegocio =='Sísmica'){this.dataChart3sismica[2].value ++}else
  if(doc.data().status == 'Cerrado'  && doc.data().unidadDeNegocio =='Sísmica'){this.dataChart3sismica[3].value ++}else
  if(doc.data().status == 'Cerrado'  && doc.data().unidadDeNegocio =='Sísmica'){this.dataChart3sismica[4].value ++}
}

// Proyectos y facilidades
clasificaChart7(doc){
  if(doc.data().status == 'Pendiente de aprobación' && doc.data().unidadDeNegocio =='Proyectos y facilidades'  ){this.dataChart3ProyectosYfacilidades[0].value ++}else
  if(doc.data().status == 'Aprobado' && doc.data().unidadDeNegocio =='Proyectos y facilidades'){this.dataChart3ProyectosYfacilidades[1].value ++}else
  if(doc.data().status == 'Denegado' && doc.data().unidadDeNegocio =='Proyectos y facilidades'){this.dataChart3ProyectosYfacilidades[2].value ++}else
  if(doc.data().status == 'Cerrado'  && doc.data().unidadDeNegocio =='Proyectos y facilidades'){this.dataChart3ProyectosYfacilidades[3].value ++}else
  if(doc.data().status == 'Cerrado'  && doc.data().unidadDeNegocio =='Proyectos y facilidades'){this.dataChart3ProyectosYfacilidades[4].value ++}
}

// Logística
clasificaChart8(doc){
  if(doc.data().status == 'Pendiente de aprobación' && doc.data().unidadDeNegocio =='Logística'  ){this.dataChart3Logistica[0].value ++}else
  if(doc.data().status == 'Aprobado' && doc.data().unidadDeNegocio =='Logística'){this.dataChart3Logistica[1].value ++}else
  if(doc.data().status == 'Denegado' && doc.data().unidadDeNegocio =='Logística'){this.dataChart3Logistica[2].value ++}else
  if(doc.data().status == 'Cerrado'  && doc.data().unidadDeNegocio =='Logística'){this.dataChart3Logistica[3].value ++}else
  if(doc.data().status == 'Cerrado'  && doc.data().unidadDeNegocio =='Logística'){this.dataChart3Logistica[4].value ++}
}

// Mantenimiento
clasificaChart9(doc){
  if(doc.data().status == 'Pendiente de aprobación' && doc.data().unidadDeNegocio =='Mantenimiento'  ){this.dataChart3mantenimiento[0].value ++}else
  if(doc.data().status == 'Aprobado' && doc.data().unidadDeNegocio =='Mantenimiento'){this.dataChart3mantenimiento[1].value ++}else
  if(doc.data().status == 'Denegado' && doc.data().unidadDeNegocio =='Mantenimiento'){this.dataChart3mantenimiento[2].value ++}else
  if(doc.data().status == 'Cerrado'  && doc.data().unidadDeNegocio =='Mantenimiento'){this.dataChart3mantenimiento[3].value ++}else
  if(doc.data().status == 'Cerrado'  && doc.data().unidadDeNegocio =='Mantenimiento'){this.dataChart3mantenimiento[4].value ++}
}

// Administración
clasificaChart10(doc){
  if(doc.data().status == 'Pendiente de aprobación' && doc.data().unidadDeNegocio =='Administración'  ){this.dataChart3administracion[0].value ++}else
  if(doc.data().status == 'Aprobado' && doc.data().unidadDeNegocio =='Administración'){this.dataChart3administracion[1].value ++}else
  if(doc.data().status == 'Denegado' && doc.data().unidadDeNegocio =='Administración'){this.dataChart3administracion[2].value ++}else
  if(doc.data().status == 'Cerrado'  && doc.data().unidadDeNegocio =='Administración'){this.dataChart3administracion[3].value ++}else
  if(doc.data().status == 'Cerrado'  && doc.data().unidadDeNegocio =='Administración'){this.dataChart3administracion[4].value ++}
}

resetea(callback){
  this.dataChart1[0].series[0].value=0
  this.dataChart1[0].series[1].value=0
  this.dataChart1[0].series[2].value=0
  this.dataChart1[0].series[3].value=0
  // this.dataChart1[0].series[4].value=0
  // this.dataChart1[0].series[5].value=0

  this.dataChart1[1].series[0].value=0
  this.dataChart1[1].series[1].value=0
  this.dataChart1[1].series[2].value=0
  this.dataChart1[1].series[3].value=0
  // this.dataChart1[1].series[4].value=0
  // this.dataChart1[1].series[5].value=0

  this.dataChart1[2].series[0].value=0
  this.dataChart1[2].series[1].value=0
  this.dataChart1[2].series[2].value=0
  this.dataChart1[2].series[3].value=0
  // this.dataChart1[2].series[4].value=0
  // this.dataChart1[2].series[5].value=0

  this.dataChart1[3].series[0].value=0
  this.dataChart1[3].series[1].value=0
  this.dataChart1[3].series[2].value=0
  this.dataChart1[3].series[3].value=0
  // this.dataChart1[3].series[4].value=0
  // this.dataChart1[3].series[5].value=0

  this.dataChart1[4].series[0].value=0
  this.dataChart1[4].series[1].value=0
  this.dataChart1[4].series[2].value=0
  this.dataChart1[4].series[3].value=0
  // this.dataChart1[4].series[4].value=0
  // this.dataChart1[4].series[5].value=0

  this.dataChart1[5].series[0].value=0
  this.dataChart1[5].series[1].value=0
  this.dataChart1[5].series[2].value=0
  this.dataChart1[5].series[3].value=0
  // this.dataChart1[5].series[4].value=0
  // this.dataChart1[5].series[5].value=0

  this.dataChart1[6].series[0].value=0
  this.dataChart1[6].series[1].value=0
  this.dataChart1[6].series[2].value=0
  this.dataChart1[6].series[3].value=0
  // this.dataChart1[6].series[4].value=0
  // this.dataChart1[6].series[5].value=0

  this.dataChart1[7].series[0].value=0
  this.dataChart1[7].series[1].value=0
  this.dataChart1[7].series[2].value=0
  this.dataChart1[7].series[3].value=0
  // this.dataChart1[7].series[4].value=0
  // this.dataChart1[7].series[5].value=0

  this.dataChart1[8].series[0].value=0
  this.dataChart1[8].series[1].value=0
  this.dataChart1[8].series[2].value=0
  this.dataChart1[8].series[3].value=0
  // this.dataChart1[8].series[4].value=0
  // this.dataChart1[8].series[5].value=0

  this.dataChart1[9].series[0].value=0
  this.dataChart1[9].series[1].value=0
  this.dataChart1[9].series[2].value=0
  this.dataChart1[9].series[3].value=0
  // this.dataChart1[8].series[4].value=0
  // this.dataChart1[8].series[5].value=0


  

  this.dataChart2[0].value=0
  this.dataChart2[1].value=0
  this.dataChart2[2].value=0
  this.dataChart2[3].value=0
  this.dataChart2[4].value=0
  this.dataChart2[5].value=0
  this.dataChart2[6].value=0
  this.dataChart2[7].value=0
  this.dataChart2[8].value=0
  this.dataChart2[9].value=0


  this.dataChart3Logistica[0].value=0
  this.dataChart3Logistica[1].value=0
  this.dataChart3Logistica[2].value=0
  this.dataChart3Logistica[3].value=0
  this.dataChart3Logistica[4].value=0
  // this.dataChart3Logistica[5].value=0

  this.dataChart3Produccion[0].value=0
  this.dataChart3Produccion[1].value=0
  this.dataChart3Produccion[2].value=0
  this.dataChart3Produccion[3].value=0
  this.dataChart3Produccion[4].value=0
  // this.dataChart3Produccion[5].value=0

  this.dataChart3ProyectosYfacilidades[0].value=0
  this.dataChart3ProyectosYfacilidades[1].value=0
  this.dataChart3ProyectosYfacilidades[2].value=0
  this.dataChart3ProyectosYfacilidades[3].value=0
  this.dataChart3ProyectosYfacilidades[4].value=0
  // this.dataChart3ProyectosYfacilidades[5].value=0

  this.dataChart3administracion[0].value=0
  this.dataChart3administracion[1].value=0
  this.dataChart3administracion[2].value=0
  this.dataChart3administracion[3].value=0
  this.dataChart3administracion[4].value=0
  // this.dataChart3administracion[5].value=0

  this.dataChart3drilling[0].value=0
  this.dataChart3drilling[1].value=0
  this.dataChart3drilling[2].value=0
  this.dataChart3drilling[3].value=0
  this.dataChart3drilling[4].value=0
  // this.dataChart3drilling[5].value=0

  this.dataChart3mantenimiento[0].value=0
  this.dataChart3mantenimiento[1].value=0
  this.dataChart3mantenimiento[2].value=0
  this.dataChart3mantenimiento[3].value=0
  this.dataChart3mantenimiento[4].value=0
  // this.dataChart3mantenimiento[5].value=0

  this.dataChart3sismica[0].value=0
  this.dataChart3sismica[1].value=0
  this.dataChart3sismica[2].value=0
  this.dataChart3sismica[3].value=0
  this.dataChart3sismica[4].value=0
  // this.dataChart3sismica[5].value=0

  this.dataChart3workover[0].value=0
  this.dataChart3workover[1].value=0
  this.dataChart3workover[2].value=0
  this.dataChart3workover[3].value=0
  this.dataChart3workover[4].value=0
  // this.dataChart3workover[5].value=0

  callback()
}

// Drilling
// Producción
// Workover
// Sísmica
// Proyectos y facilidades
// Logística
// Mantenimiento
// Administración

}// fin de clase

